import React from 'react';
import * as Raven from 'raven-js';
import Form from 'antd/lib/form';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
var Option = Select.Option;
import IconTrophyFirst from 'src/imports/components/Scoreboard/components/IconDashboard/IconTrophyFirst';
import IconTrophySecond from 'src/imports/components/Scoreboard/components/IconDashboard/IconTrophySecond';
import IconTrophyThird from 'src/imports/components/Scoreboard/components/IconDashboard/IconTrophyThird';
import IconQualified from 'src/imports/components/Scoreboard/components/IconDashboard/IconQualified';
import IconDisqualified from 'src/imports/components/Scoreboard/components/IconDashboard/IconDisqualified';
import IconInjured from 'src/imports/components/Scoreboard/components/IconDashboard/IconInjured';
import IconOweMoney from 'src/imports/components/Scoreboard/components/IconDashboard/IconOweMoney';
var formStyles = require('src/imports/styles/extend.form.scss');
var InputStatusIcons = function (props) {
    var iconValue = [];
    try {
        if (props.initialValue) {
            iconValue = typeof props.initialValue === 'string'
                ? JSON.parse(props.initialValue)
                : props.initialValue;
        }
    }
    catch (err) {
        Raven.captureException(err);
    }
    return (React.createElement(Form.Item, { label: React.createElement("span", { className: formStyles.optional }, "Status Icons"), colon: false }, props.form.getFieldDecorator('statusIcons', {
        initialValue: iconValue,
        rules: [{
                type: 'array',
            }],
    })(React.createElement(Select, { mode: 'multiple', size: 'large', placeholder: '', style: { fontSize: '1.4rem' }, disabled: props.isDisabled },
        React.createElement(Option, { value: 'IconTrophyFirst' },
            React.createElement(IconTrophyFirst, null),
            " First"),
        React.createElement(Option, { value: 'IconTrophySecond' },
            React.createElement(IconTrophySecond, null),
            " Second"),
        React.createElement(Option, { value: 'IconTrophyThird' },
            React.createElement(IconTrophyThird, null),
            " Third"),
        React.createElement(Option, { value: 'IconQualified' },
            React.createElement(IconQualified, null),
            " Qualified"),
        React.createElement(Option, { value: 'IconDisqualified' },
            React.createElement(IconDisqualified, null),
            " Disqualified"),
        React.createElement(Option, { value: 'IconInjured' },
            React.createElement(IconInjured, null),
            " Injured"),
        React.createElement(Option, { value: 'IconOweMoney' },
            React.createElement(IconOweMoney, null),
            " Owe $$")))));
};
export default InputStatusIcons;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageDashboard/DashboardForm/DashboardFormTeamAthleteScore/FormScore/InputStatusIcons.tsx
// module id = 390
// module chunks = 0